module.exports = {
      id: "Infobulle 2-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Infobulle 2-usage",
      toString: function () {
        return this.url;
      }
    }